/** Syndiqia wordmark (vector); switches to the light-lettered variant on dark backgrounds. */
export function Logo({ height = 26 }: { height?: number }) {
  const width = Math.round((height * 1680) / 398); // viewBox of logo.svg
  return (
    <picture>
      <source srcSet="/logo-dark.svg" media="(prefers-color-scheme: dark)" />
      <img src="/logo.svg" alt="Syndiqia" width={width} height={height} className="logo" />
    </picture>
  );
}
